import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import Highlighter from 'react-highlight-words'
import classnames from 'classnames'
import { Loader } from 'components/util'
import SingleSelectField from 'components/forms/SingleSelectField/SingleSelectField'
import * as actions from 'services/activityTypes/actions'
import * as activityTypes from 'services/activityTypes/selectors'
import styles from './_activityTypeSelector.css'

const mapStateToProps = state => ({
  options: activityTypes.selectActivityTypeOptions(state),
  flatOptions: activityTypes.selectFlatActivityTypeOptions(state),
  filterOptions: activityTypes.selectFilterOptions(state),
})

const mapDispatchToActions = {
  ...actions,
}

export class ActivityTypeSelector extends Component {

  static propTypes = {
    error: PropTypes.bool,
    loading: PropTypes.bool,
    options: PropTypes.array,
    flatOptions: PropTypes.array,
    fetchActivityTypes: PropTypes.func,
    filterOptions: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this._inputValue = ''
    this.state = {
      loading: false,
      error: false,
    }
  }

  componentWillMount () {
    this.loadActivityTypes()
  }

  loadActivityTypes = () => {
    this.setState({ loading: true })
    this.props.fetchActivityTypes()
      .then(() => this.setState({ loading: false, error: false }))
      .catch(() => this.setState({ loading: false, error: true }))
  }

  handleRetry = () => {
    this.loadActivityTypes()
  }

  renderOption = ({ option, focusedOption, valueArray, selectValue, focusOption, style, key }) => {
    return (
      <div
        key={key}
        onClick={() => selectValue(option)}
        onMouseOver={() => focusOption(option)}
        style={style}
        className={classnames(styles.option, {
          [styles.group]: option.options,
          [styles.child]: !option.options,
          [styles.selected]: valueArray.indexOf(option) >= 0,
          [styles.focused]: option === focusedOption,
        })}
      >
        <Highlighter
          autoEscape
          searchWords={[this._inputValue]}
          textToHighlight={option.label}
        />
      </div>
    )
  }

  renderValue = (option) => {
    return (
      <div>{option.label}</div>
    )
  }

  handleClose = () => {
    this._inputValue = ''
  }

  render () {
    const { loading, error } = this.state
    const { flatOptions, filterOptions, ...props } = this.props

    return (
      <div className={classnames(styles.container, { [styles.loading]: loading })}>
        {error ?
          <div className={styles.error}>
            <FormattedMessage
              id='forms.activityTypeSelector.error_loading'
              defaultMessage='Error loading activity types.'
            /> &nbsp;
            <span className={styles.retry} onClick={this.handleRetry}>
              <FormattedMessage
                id='forms.activityTypeSelector.error_loading_retry'
                defaultMessage='Retry?'
              />
            </span>
          </div>
        : null}

        {loading ?
          <div className={styles.loader}>
            <Loader type='ios' height={20} width={20} />
          </div>
        : null}

        <SingleSelectField
          {...props}
          virtualized
          maxHeight={168}
          optionHeight={24}
          onClose={this.handleClose}
          className={styles.select}
          options={flatOptions}
          filterOptions={filterOptions}
          optionRenderer={this.renderOption}
          onInputChange={(inputValue) => { this._inputValue = inputValue }}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(ActivityTypeSelector)



// WEBPACK FOOTER //
// ./src/components/forms/ActivityTypeSelector/ActivityTypeSelector.jsx